import { render, staticRenderFns } from "./AppointmentProcedureList.vue?vue&type=template&id=7ac3b763&scoped=true&"
import script from "./AppointmentProcedureList.vue?vue&type=script&lang=js&"
export * from "./AppointmentProcedureList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ac3b763",
  null
  
)

export default component.exports